export default "assets/images/texture-piscine-2b1f28e9.jpg";